import { useEffect, useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Switch } from "../ui/switch";

export function AccountantPanel() {
  const [d, setD] = useState(null);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const apply = (x) => { setD(x); setEmail(x.email); };
  useEffect(() => { api.get("/admin/accountant").then((r) => apply(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const save = async (enabled = d.enabled) => { try { apply((await api.put("/admin/accountant", { email, enabled })).data); toast.success("Accountant settings saved"); } catch (e) { toast.error(errMsg(e)); } };
  const sendNow = async () => {
    setBusy(true);
    try { const { data } = await api.post("/admin/accountant/send"); data.ok ? toast.success(`Report for ${data.month} sent to ${data.to}`) : toast.error("The email could not be sent right now"); apply((await api.get("/admin/accountant")).data); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="panel p-4 space-y-3" data-testid="accountant-panel">
      <div className="flex flex-wrap justify-between items-center gap-2">
        <p className="eyebrow flex items-center gap-1"><Send size={12} />Accountant auto-send</p>
        <label className="flex items-center gap-2 text-xs text-slate-400">Send automatically<Switch checked={d.enabled} onCheckedChange={(v) => save(v)} data-testid="accountant-enabled" /></label>
      </div>
      <p className="text-xs text-slate-500">On the 1st of each month ({d.schedule}) your accountant gets an email with last month's totals and a 30-day download link to both spreadsheets.</p>
      <div className="flex flex-wrap gap-2">
        <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" className="h-9 max-w-xs text-sm" data-testid="accountant-email" />
        <Button size="sm" variant="outline" className="border-slate-700" onClick={() => save()} disabled={email === d.email} data-testid="accountant-save">Save</Button>
        <Button size="sm" className="bg-amber-600" onClick={sendNow} disabled={busy || !d.email} data-testid="accountant-send-now">{busy ? "Sending…" : `Send ${d.next_month} report now`}</Button>
      </div>
      {d.sends.length > 0 && <div className="text-[11px] text-slate-500 space-y-0.5" data-testid="accountant-sends">{d.sends.slice(0, 4).map((s) => <p key={s.id}>{fmtDate(s.created_at)} · {s.month} → {s.to} · <span className={s.ok ? "text-emerald-400" : "text-red-400"}>{s.ok ? "sent" : "failed"}</span>{s.by === "system" ? " · automatic" : ""}</p>)}</div>}
    </div>
  );
}
